<h3 class="mat-typography">Dokumente</h3>
<p class="mat-typography">Mitgesendete Dokumente werden automatisch im Kundenportal zur Verfügung gestellt.</p>
<p class="mat-typography">Bitte senden Sie nur Dokumente mit, die für die Kundenberatung von Relevanz sein können,
wie z.B. Exposé, Fotos der Immobilie, Grundbuchauszug, Grundriss, Baubeschreibung, Energieausweis, Lageplan / Flurkarte, etc.</p>

